/**
 * Formats a phone number from "+14022354774" format to "(402) 235 4774" format
 * @param phoneNumber - The phone number string to format
 * @returns Formatted phone number string
 */
export function formatPhoneNumber(phoneNumber: string): string {
  if (!phoneNumber) return '';
  
  // Remove all non-digit characters
  const digits = phoneNumber.replace(/\D/g, '');
  
  // Handle US phone numbers (11 digits starting with 1)
  if (digits.length === 11 && digits.startsWith('1')) {
    const areaCode = digits.slice(1, 4);
    const exchange = digits.slice(4, 7);
    const number = digits.slice(7, 11);
    return `(${areaCode}) ${exchange}-${number}`;
  }
  
  // Handle 10-digit US phone numbers
  if (digits.length === 10) {
    const areaCode = digits.slice(0, 3);
    const exchange = digits.slice(3, 6);
    const number = digits.slice(6, 10);
    return `(${areaCode}) ${exchange}-${number}`;
  }
  
  // Return original if it doesn't match expected formats
  return phoneNumber;
} 